import { render, staticRenderFns } from "./DictionaryCreation.vue?vue&type=template&id=44695a70&scoped=true&"
import script from "./DictionaryCreation.vue?vue&type=script&lang=js&"
export * from "./DictionaryCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44695a70",
  null
  
)

export default component.exports